// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type Highlights48Props = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const Highlights48: FC<Highlights48Props> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="48"
            height="48"
        >
            <path d="m42.6 36.7-5.3-5.3 2.1-2.1 5.3 5.3-2.1 2.1Zm-7.2-24-2.1-2.1 5.3-5.3 2.1 2.1-5.3 5.3Zm-22.8 0L7.3 7.4l2.1-2.1 5.3 5.3-2.1 2.1Zm-7.2 24-2.1-2.1 5.3-5.3 2.1 2.1-5.3 5.3Zm10.75-.95 7.85-4.7 7.85 4.75-2.1-8.9 6.9-6-9.1-.8L24 11.7l-3.55 8.35-9.1.8 6.9 6-2.1 8.9ZM11.65 42l3.25-14.05L4 18.5l14.4-1.25L24 4l5.6 13.25L44 18.5l-10.9 9.45L36.35 42 24 34.55 11.65 42Z" />
        </svg>
    );
};

export default Highlights48;
